<script>
import functionalFeatureScriptLoaderMixin from "../../mixins/functionalFeatureScriptLoaderMixin";

export default {
  name: "ScriptLoaderHotjar",
  mixins: [functionalFeatureScriptLoaderMixin],
  props: {
    hotjarId: {
      required: true,
      type: String,
    },
  },
  methods: {
    initFunctionalFeatureScript() {
      window.hj =
        window.hj ||
        function() {
          (window.hj.q = window.hj.q || []).push(arguments);
        };
      const script = document.createElement("script");
      script.async = 1;
      script.src = `https://static.hotjar.com/c/hotjar-${this.hotjarId}.js?sv=6`;
      document.head.appendChild(script);
    },
  },
};
</script>
